import { zodMoment } from '@qapline/helpers';
import { z } from 'zod';

export const attachmentTypeEnum = z.enum(['INVOICE', 'DELIVERY_NOTE']);
export type TAttachmentType = z.infer<typeof attachmentTypeEnum>;

export const attachmentSchema = z.object({
    attachment_id: z.number(),
    name: z.string(),
    fileName: z.string(),
    mimeType: z.string(),
    type: attachmentTypeEnum,
    sent: z.boolean(),
    dueDate: zodMoment().nullable(),
    paymentDate: zodMoment().nullable(),
    tsAdded: zodMoment(),
    deleted: z.boolean(),
    user_id: z.number().nullable(),
    commission_id: z.number().nullable(),
    invoice_id: z.number().nullable(),
    invoiceCustomerEmail: z.string().nullish(),
    invoiceLanguage: z.string().nullish(),
});
export type TAttachment = z.infer<typeof attachmentSchema>;
